<div mdbTooltip="{{mdbTooltip}}" container="body" placement="bottom" style="padding-right: 15px">
  <a [mdbPopover]="popTemplate" container="body" [outsideClick]="true" placement="bottom" [isOpen]="popoverOpen"
     class="nav-link waves-light" mdbWavesEffect>
    <span></span>
    <mdb-icon fas [icon]="faIcon" style="width:16px;height:16px;" [style.color]="(queue | async )?.length ? '#00659c' : 'green'">
    </mdb-icon>
    <mdb-badge color="orange" *ngIf="fileCounter">
      {{fileCounter}}
    </mdb-badge>
  </a>
</div>


<ng-template #popTemplate let-message="message">
  <div style="padding: 10px !important">
    <div class="row"  *ngFor="let item of queue | async">
      <div style="width: 300px">
        <div><strong mdbTooltip="{{item?.file?.name}}" placement="bottom" container="body">{{item?.file?.name  | limitTo: 25}} </strong>
        </div>
        <div>
          <mdb-progress value="{{item.progress}}" min="0" max="100" [type]="uploadStatus(item)"
            aria-valuenow="item.progress" aria-valuemin="0" aria-valuemax="100">
            {{item.progress}}</mdb-progress>
        </div>
      </div>
    </div>
    <div *ngIf="!(queue | async )?.length">
      {{'administration_noFilesInQueue_label' | translate}}
    </div>
  </div>
</ng-template>
